import { FC, useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import CoApplicant from './CoApplicant'
// import LoanType from "./LoanType";
import CoApplicantComplete from './CoApplicantComplete'
import { useDispatch, useSelector } from 'react-redux'
import { parse } from 'query-string'
import { getIntegrationURLFromENV } from '../../../utils/getIntegrationURLFromENV'
import axios from 'axios'
import { setFundDetails } from './redux/actions'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const CoApplicantWrapper: FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const searchQuery: any = parse(history.location.search)
  const partnerDetails = useSelector((state: any) => state.coApplicant.partner)
  useEffect(() => {
    if (partnerDetails != null && partnerDetails?.funds?.length > 0) {
      const selectedFund = partnerDetails?.funds[0]
      getFundDetails(selectedFund)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerDetails?.funds?.length])

  const getFundDetails = async (fundId: string) => {
    const env = localStorage.getItem('env')
    const API_URL = getIntegrationURLFromENV(searchQuery?.env || env)
    const fundData = await axios.get(`${API_URL}ext/api/funds/${fundId || ''}`)

    if (fundData.data && fundData.status === 200) {
      dispatch(setFundDetails(fundData.data))
    }
  }

  return (
    <>
      <div className='headerAlexi'>
        <div className='container'>
          <div className='d-flex w-100'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/ccrLogo.png')} />
            <div className='ms-auto d-flex justify-content-center'>
              <div className='symbol symbol-35px symbol-circle d-flex align-items-center justify-content-center'>
                <span className='symbol-label bg-secondary text-inverse-secondary fw-bolder'>
                  CK
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Switch>
        <Route path='/co-applicant/completed' exact>
          {' '}
          <CoApplicantComplete />{' '}
        </Route>
        <Route path='/co-applicant' exact>
          {' '}
          <CoApplicant />{' '}
        </Route>
        <Route path='/co-applicant/:id' exact>
          <CoApplicant />
        </Route>
      </Switch>
    </>
  )
}

export default CoApplicantWrapper
